module.exports = "<svg version=\"1.0\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 131.3 131.3\" enable-background=\"new 0 0 131.3 131.3\" xml:space=\"preserve\"><g><path fill=\"#FFFFFF\" d=\"M25.5,131.3H0V95.4C7.7,108.7,18.2,122.4,25.5,131.3z M55.9,64.4c0-12.1-9.8-22-22-22c-12.1,0-22,9.8-22,22 c0,12.1,9.8,22,22,22C46.1,86.3,55.9,76.5,55.9,64.4z M131.3,0v131.3H42.4C55.2,115.7,77.9,85.5,77.9,68 c0-24.3-19.7-43.9-43.9-43.9c-13.7,0-25.9,6.3-33.9,16V0H131.3z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/view/Dashboard/only_logo.svg
// module id = 925
// module chunks = 0